module.exports = __webpack_public_path__ + "media/images/apple-icon-144x144-6086c05d.png";